import { useMemo } from 'react';
import { prop } from 'ramda';
import { usePortletSelector } from 'js/components/system/Portlet';
import { EDITABLE_DD_MODES } from 'js/components/common/Fields/EditableDropDown/constants';

import { ADDITIONAL_OPTIONS, PREDEFINED_TYPES } from '../constants';

export const useEddConfig = () => {
    const config = usePortletSelector(prop('config'));

    return useMemo(() => {
        const {
            predefinedType,
            noLimitsAllowed,
            predefinedLimits = []
        } = config;
        const { LIST_ONLY, TEXT_ONLY, ALL } = EDITABLE_DD_MODES;
        const { FORCED, DISABLED } = PREDEFINED_TYPES;
        const { unlimited, empty } = ADDITIONAL_OPTIONS;

        return {
            mode: predefinedType === FORCED
                ? LIST_ONLY
                : !noLimitsAllowed && predefinedType === DISABLED
                    ? TEXT_ONLY
                    : ALL,
            dataList: [
                ...predefinedType === FORCED ? [empty] : [],
                ...predefinedLimits,
                ...noLimitsAllowed ? [unlimited] : []
            ],
            displayValuesMap: {
                [unlimited.value]: unlimited.displayValueTKey
            }
        };
    }, [config]);
};
